import PropTypes from "prop-types";

import { alignItems } from "../../consts";

import FlexContainers from "../Containers/FlexContainers";
import WrapperContainer from "../Containers/WrapperContainer";
import { Step } from "./Step";

const Stepper = ({ stepConfigs = [], activeStep, setActiveStep }) => {
  return (
    <WrapperContainer
      Container={FlexContainers.FlexColumnStart}
      alignItems={alignItems.start}
      width="100%">
      {stepConfigs.map((config) => {
        return (
          <Step
            key={config.step}
            step={config.step}
            title={config.title}
            DividerContent={config.DividerContent}
            isActive={config.step === activeStep}
            isDisabled={config.disabled}
            setActiveStep={setActiveStep}
          />
        );
      })}
    </WrapperContainer>
  );
};

Stepper.propTypes = {
  stepConfigs: PropTypes.shape({
    step: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    DividerContent: PropTypes.node,
    disabled: PropTypes.bool
  }).isRequired,

  activeStep: PropTypes.number.isRequired,
  setActiveStep: PropTypes.func
};

export default Stepper;
